import axios from 'axios'
import { dispatch, store } from '../redux/store';
import { handlerefreshToken } from './Auth/authService';
import { setLoggedOut, setUserToken } from '../redux/auth/authSlice';

const axiosInstance = axios.create({
    baseURL: 'https://api-dev.spark.hushl.in/',
    timeout: 9000,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
    (config) => {
      // console.log('Request: ', JSON.stringify(config, null, 2))
      const { userToken } = store.getState().user;
      if (userToken) {
        config.headers.Authorization = `Bearer ${userToken}`;
      }
      return config;
    },
    (error) => {
      // console.log("error in request: ", error)
      return Promise.reject(error);
    }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
    (response) => {
      // console.log('Response: ', JSON.stringify(response, null, 2))
      return response;
    },
    async (error) => {
      // console.log('Response: ', JSON.stringify(error, null, 2))
      const originalRequest = error.config;
      if(error.response.status === 401 && !originalRequest._retry){
        originalRequest._retry = true; // Mark the request as retried to avoid infinite loops.
        try{
          const accessToken = await handlerefreshToken();
          if (accessToken) {
            dispatch(setUserToken(accessToken))
            originalRequest.headers.Authorization = `Bearer ${accessToken}`;
            return axiosInstance(originalRequest);
          }
        }catch(refreshError){
          // Handle refresh token errors by clearing stored tokens and redirecting to the login page.
          console.error('Token refresh failed:', refreshError);
          dispatch(setLoggedOut())
          return Promise.reject(refreshError);
        }
      }
      dispatch(setLoggedOut())  
      return Promise.reject(error);
    }
);

export default axiosInstance;